import { addDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";
import { getIssuableInfinityCards } from "../game/cardPackEngine";

export async function ensureInitialSignupRewards(userId) {
  if (!userId) return false;

  const rewardsRef = collection(db, "users", userId, "rewards");
  const rewardsSnap = await getDocs(rewardsRef);
  const existingRewards = rewardsSnap.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  const existingStarterPackCount = existingRewards.filter(
    (reward) => reward.type === "card pack",
  ).length;
  const existingStarterCharacterCount = existingRewards.filter(
    (reward) => reward.type === "character card",
  ).length;
  const existingStarterTokenCount = existingRewards.filter(
    (reward) => reward.type === "infinity tokens",
  ).length;

  if (
    existingStarterPackCount >= 4 &&
    existingStarterCharacterCount >= 1 &&
    existingStarterTokenCount >= 1
  ) {
    return false;
  }

  const [charactersSnap, infinitySnap] = await Promise.all([
    getDocs(collection(db, "Character cards")),
    getDocs(collection(db, "Infinity cards")),
  ]);

  const characterCards = charactersSnap.docs
    .map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }))
    .map((card) => ({
      ...card,
      type: "character",
      _uuid: `${Date.now()}-${Math.random()}`,
    }))
    .filter(
      (card) =>
        card.name === "Zaporia" ||
        card.name === "Toshi" ||
        card.name === "Ashro",
    );

  let infinityCards = infinitySnap.docs
    .map((doc) => ({
      id: doc.id,
      ...doc.data(),
      _uuid: `${Date.now()}-${Math.random()}`,
    }))
    .filter((card) => card.finite !== "TRUE");

  infinityCards = getIssuableInfinityCards(infinityCards);

  if (characterCards.length === 0 || infinityCards.length < 40) {
    console.warn("Not enough cards to issue signup rewards.");
    return false;
  }

  const shuffleArray = (arr) => {
    const shuffled = [...arr];
    for (let i = shuffled.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const shuffledInfinity = shuffleArray(infinityCards).slice(0, 40);
  const cardPacks = [];

  for (let i = 0; i < 4; i += 1) {
    cardPacks.push(shuffledInfinity.slice(i * 10, i * 10 + 10));
  }

  const getRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

  if (existingStarterCharacterCount < 1) {
    await addDoc(rewardsRef, {
      type: "character card",
      issuedAt: Date.now(),
      claimed: false,
      reward: getRandom(characterCards),
      amount: 1,
      source: "initial_signup",
    });
  }

  for (let i = existingStarterPackCount; i < 4; i += 1) {
    await addDoc(rewardsRef, {
      type: "card pack",
      issuedAt: Date.now(),
      claimed: false,
      reward: {
        pack: {
          cards: cardPacks[i],
        },
      },
      amount: 1,
      source: "initial_signup",
    });
  }

  if (existingStarterTokenCount < 1) {
    await addDoc(rewardsRef, {
      type: "infinity tokens",
      issuedAt: Date.now(),
      claimed: false,
      reward: { currency: "Infinity Tokens" },
      amount: 250,
      source: "initial_signup",
    });
  }

  return true;
}

export async function ensureTutorialCompletionReward(userId) {
  if (!userId) return false;

  const rewardsRef = collection(db, "users", userId, "rewards");
  const rewardsSnap = await getDocs(rewardsRef);
  const hasTutorialReward = rewardsSnap.docs.some((rewardDoc) => {
    const reward = rewardDoc.data() || {};
    return reward.description === "Reward for completing the tutorial";
  });

  if (hasTutorialReward) {
    return false;
  }

  const ownedInfinitySnap = await getDocs(
    collection(db, "users", userId, "Infinity cards"),
  );
  const alreadyOwnsReward = ownedInfinitySnap.docs.some(
    (cardDoc) => cardDoc.id === "bnySrxduySbFQmSdyRHs",
  );

  if (alreadyOwnsReward) {
    return false;
  }

  const cardsSnap = await getDocs(collection(db, "Infinity cards"));
  const totemCard = getIssuableInfinityCards(
    cardsSnap.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .map((card) => ({
        ...card,
        type: "Infinity",
      })),
  ).find((card) => card.id === "bnySrxduySbFQmSdyRHs");

  if (!totemCard) {
    return false;
  }

  await addDoc(rewardsRef, {
    type: "finite card",
    issuedAt: Date.now(),
    claimed: false,
    reward: totemCard,
    amount: 1,
    description: "Reward for completing the tutorial",
  });

  return true;
}
